export default __webpack_public_path__ + "static/Antti-Karppinen-9555008af4c1c1c5e5fa3bd831c6f2be.png";